import MasterCrudPage from "../../components/MasterCrudPage";
import {
  socialMediaMasterApi,
  userMasterApi,
  userSocialMediaProfileApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function UserSocialMedia() {
  return (
    <MasterCrudPage
      title="User Social Media Profile"
      description="Link social media URLs to a user. Platforms come from Social Media Master."
      idKey="user_social_media_id"
      api={userSocialMediaProfileApi}
      listLabel="social profiles"
      scopeToCurrentUser
      loadExtraOptions={async () => {
        const [users, platforms] = await Promise.all([
          userMasterApi.list(),
          socialMediaMasterApi.list(),
        ]);
        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
          platforms: (platforms || []).map((platform) => ({
            value: platform.social_media_id,
            label: platform.social_media_platform,
          })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "social_media_id",
          label: "Social Media",
          type: "select",
          required: true,
          optionsKey: "platforms",
          placeholder: "Select platform",
        },
        {
          name: "url",
          label: "URL",
          type: "text",
          required: true,
          placeholder: "https://...",
        },
        {
          name: "social_media_verified",
          label: "Is Social Media Profile Verified",
          type: "checkbox",
          defaultValue: false,
          checkLabel: "Yes",
          verificationField: true,
        },
        {
          name: "social_media_verification_by",
          label: "Social Media Profile Verification By",
          type: "text",
          placeholder: "Verifier name",
          verificationField: true,
        },
        {
          name: "social_media_verification_date",
          label: "Social Media Profile Verification Date",
          type: "date",
          verificationField: true,
        },
        {
          name: "social_media_verification_certificate",
          label: "Social Media Profile Verification Certificate",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
          verificationField: true,
        },
      ]}
      columns={[
        { key: "user_social_media_id", label: "ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.user_id, item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        { key: "social_media_platform", label: "Platform" },
        { key: "url", label: "URL" },
        { key: "social_media_verified", label: "Verified", render: (item) => (Number(item.social_media_verified) === 1 ? "Yes" : "No") },
        { key: "social_media_verification_by", label: "Verified By" },
        { key: "social_media_verification_date", label: "Verified Date" },
      ]}
    />
  );
}
